import { z } from 'zod';
import { CalendarDateOnlySchema } from './common.js';
export const PaymentCandidateLinesQuerySchema = z.strictObject({
    from: CalendarDateOnlySchema,
    to: CalendarDateOnlySchema,
}).refine(({ from, to }) => {
    const days = (Date.parse(to) - Date.parse(from)) / 86_400_000;
    return days >= 0 && days <= 120;
}, { message: 'The date window must be ordered and span at most 120 days' });
export const PaymentCandidateLineAllocationStateSchema = z.enum([
    'UNALLOCATED', 'SETTLES_THIS_SUPPLIER_INVOICE', 'LEDGER_ACCOUNTS_ONLY', 'OTHER',
]);
export const PaymentCandidateLineSchema = z.object({
    lineId: z.string().uuid(),
    bankAccountId: z.string().uuid(),
    date: CalendarDateOnlySchema,
    amountTies: z.boolean(),
    identifierMatch: z.enum(["supplier's name", 'reference']).nullable(),
    allocationState: PaymentCandidateLineAllocationStateSchema,
});
export const PaymentCandidateLinesResponseSchema = z.object({
    candidates: z.array(PaymentCandidateLineSchema),
    truncated: z.boolean(),
});
